/**
 * @license
 * Copyright (c) 2004 %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
const u = /^\s*|\s*$/g;
function i(n) {
  if (n === null)
    return !0;
  const e = f(n);
  return e != null && e.hasOwnProperty("length") ? e.length === 0 : !0;
}
function c(n) {
  return !!(n === void 0 || i(n));
}
function o(n) {
  return n !== null && (typeof n == "string" || n instanceof String);
}
function f(n) {
  return o(n) ? n.replace(u, "") : n;
}
function s(n) {
  let e = 0;
  if (n.length === 0)
    return e;
  for (let t = 0; t < n.length; t++) {
    const r = n.charCodeAt(t);
    e = (e << 5) - e + r, e &= e;
  }
  return e;
}
const h = (n) => n.replace(/(?!^)([A-Z\u00C0-\u00D6])/g, (e) => "-" + e.toLowerCase()), g = (n) => {
  const e = n.match(/^var\((.*)\)$/);
  return e ? e[1] : n;
};
function l(n, e = " ") {
  return n.filter(Boolean).join(e) || void 0;
}
export {
  g as getVarName,
  s as hashCode,
  i as isEmpty,
  c as isEmptyOrUndefined,
  o as isString,
  h as kebabCase,
  l as merge,
  f as trim
};
//# sourceMappingURL=stringUtils.js.map
